<template>
  <div class="card events">
    <div class="content">
      <div class="response_table">
        <table>
          <thead>
            <tr>
              <th scope="col">
                traffic_used
              </th>
              <th scope="col">
                traffic_limit
              </th>
              <th scope="col">
                date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(eve, key) in events" :key="key">
              <td>{{ eve.traffic_used }}</td>
              <td>{{ eve.traffic_limit }}</td>
              <td>{{ get_date(eve.date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="text-center">
      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        close
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ActionEvents',
  props: ['events'],
  data () {
    return {
    }
  },
  mounted(){
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
  }
}

</script>
<style lang='scss' scoped>
  .events{
    height: 500px;
    .content{
      height: 90%;
    }
  }
</style>
